import { Component, Vue } from 'nuxt-property-decorator';

@Component
export class BeforeRouteLeaveMixin extends Vue {
  async beforeRouteLeave(to, from, next: () => void) {
    if (!this.$beforeUnload.isActive) return next();
    const isNavigationConfirmed = await this.$beforeUnload.confirmNavigation();
    return isNavigationConfirmed ? next() : false;
  }
}
